import { localStorageHelper } from '../../../../../../utils/localStorageHelper'

// Per-user persistence for the trend tool's chart-type choice. Same
// shape as allocation's chartTypePreference -- validate against a
// frozen list, fall back to default on missing / invalid / corrupted
// values, no-op when userId is missing.

export const CHART_TYPES = Object.freeze(['line', 'bar'])
export const DEFAULT_CHART_TYPE = 'line'

function storageKey (userId) {
  return `portfolioExplorer.${userId}.utilityPanel.trend.chartType`
}

export function loadChartType (userId) {
  if (userId == null) return DEFAULT_CHART_TYPE
  const stored = localStorageHelper.tryLoad(storageKey(userId))
  return CHART_TYPES.includes(stored) ? stored : DEFAULT_CHART_TYPE
}

export function saveChartType (userId, type) {
  if (userId == null) return
  if (!CHART_TYPES.includes(type)) return
  localStorageHelper.tryStore(storageKey(userId), type)
}
